<template>
  <page-wrapper
    :title="'สร้างใบแจ้งหนี้'"
    :noPadBtm="true"
  >
    <div class="loader" style="margin-top: 16px;" v-if="loader"></div>
    <div class="content-wrapper">
      <!-- Header -->
      <div class="sub-title">
        <div class="title">รายละเอียดใบแจ้งหนี้</div>
        <div class="button-wrapper">
          <button class="button cancel-button" @click="handleCancelBilling">
            <img src="/static/icons/supplier-red-close-icon.svg" />ยกเลิก
          </button>
          <button class="button confirm-button ml-3" @click="handleSubmitBilling">
            <img src="/static/icons/supplier-correct-icon.svg" />ยืนยัน
          </button>
        </div>
      </div>

      <!-- Status -->
      <!-- <div class="description mt-4">
        TODO: open on phase2
        <div class="content">
          <div class="item mb-1">
            <p>เหตุผลในการไม่อนุมัติ :</p>
            <p class="status-text ml-2">ไม่ตรงกับระบบหลังบ้าน</p>
          </div>
          <div class="item mb-1">
            <p>รายละเอียดเพิ่มเติม :</p>
            <p class="value ml-2">บ้านเลขที่ 112/59 , 112/60 ไม่ตรงกับระบบหลังบ้าน</p>
          </div>
          <div class="item">
            <p>ผู้ตรวจสอบ :</p>
            <p class="value ml-2">สุริยา จันทรา</p>
          </div>
        </div>
        <div class="status background_in_progress">
          <div class="content-wrapper">
            <div class="title">สถานะ</div>
            <div class="value text_in_progress ml-2">เอกสารผ่าน</div>
          </div>
        </div>
      </div> -->
      <div class="body mt-4">
        <div class="left">
          <!-- Invoice -->
          <div class="form-wrapper">
            <div class="header">
              <div class="title">
                ใบแจ้งหนี้ <span class="required" style="font-weight: 500;">(ต้องกรอก)</span>
              </div>
              <div class="value">ใส่รายละเอียดใบแจ้งหนี้</div>
            </div>
            <div class="form">
              <div class="item">
                <p>เลขที่ใบแจ้งหนี้ <span class="required">*</span></p>
                <!-- NOTE: The one-time-code ID and name are used to disable autocomplete.  -->
                <el-input
                  id="one-time-code-1"
                  name="one-time-code-1" 
                  class="input-item"
                  type="text"
                  v-model="invoiceForm.invoiceNo"
                  placeholder="ระบุเลขที่ใบแจ้งหนี้"
                  autocomplete="off"
                  clearable />
              </div>
              <div class="item">
                <p>วันที่ในใบแจ้งหนี้ <span class="required">*</span></p>
                <el-date-picker
                  id="one-time-code-2"
                  name="one-time-code-2" 
                  class="input-item"
                  v-model="invoiceForm.dateTime"
                  placeholder="เลือกวันที่"
                  format="dd MMMM yyyy"
                  type="date"
                  autocomplete="off" />
              </div>
              <div class="item">
                <p>จำนวนเงินรวม <span class="required">*</span></p>
                <input
                  id="one-time-code-3"
                  name="one-time-code-3"
                  class="input-item currency-input"
                  :style="'--placeholder-color'"
                  type="text"
                  placeholder="ระบุจำนวนเงินรวม"
                  v-model="invoiceForm.totalPrice"
                  @focus="invoiceTotalPriceFocusInput(invoiceForm.totalPrice)"
                  @blur="invoiceTotalPriceBlurInput(invoiceForm.totalPrice)"
                  @keypress="onKeypress($event, invoiceForm.totalPrice)"
                  autocomplete="off" />
              </div>
            </div>
            <div class="preview-invoice">
              <vue-pdf-app class="display-file mb-4"
                :pdf="invoiceTempFileUrl"
                :config="vuePdfConfig"/>
              <div class="attach-file" v-if="!invoiceTempFile">
                <p>แนบใบแจ้งหนี้ <span class="required">*</span></p>
                <button class="button mt-2" @click="selectInvoiceFile">
                  <img src="/static/icons/supplier-attach-image-icon.svg" />เลือกไฟล์
                </button>
              </div>
              <div class="display-file-name mt-4 mb-2" v-else>
                <p>ไฟล์แนบ :</p>
                <div class="file-name">
                  <p>{{ invoiceTempFile.name }}</p>
                  <p class="text-button ml-3" @click="selectInvoiceFile">เลือกไฟล์</p>
                  <p class="text-button" @click="invoiceForm.uploadFile = null">ลบ</p>
                </div>
              </div>
              <input
                name="invoiceFile"
                type="file"
                accept="application/pdf"
                ref="invoiceFileRef"
                hidden
                @click="clearInvoiceFileRef"
                @change="changeInvoiceFile($event.target.files[0])"
              />
            </div>
          </div>
          <!-- Receipt -->
          <div class="form-wrapper mt-4">
            <div class="header">
              <div class="title">ใบเสร็จ</div>
              <div class="value">ใส่รายละเอียดใบเสร็จ</div>
            </div>
            <div class="form">
              <div class="item">
                <p>เลขที่ใบเสร็จ</p>
                <el-input
                  name="receiptNo"
                  class="input-item"
                  type="text"
                  v-model="receiptForm.receiptNo"
                  placeholder="ระบุเลขที่ใบเสร็จ"
                  clearable />
              </div>
              <div class="item">
                <p>วันที่ในใบเสร็จ</p>
                <el-date-picker
                  name="receiptDateTime"
                  class="input-item"
                  v-model="receiptForm.dateTime"
                  format="dd MMMM yyyy"
                  type="date"
                  placeholder="เลือกวันที่" />
              </div>
              <div class="item">
                <p>จำนวนเงินรวม</p>
                <input
                  name="receiptTotalPrice"
                  class="input-item currency-input"
                  :style="'--placeholder-color'"
                  type="text"
                  placeholder="ระบุจำนวนเงินรวม"
                  v-model="receiptForm.totalPrice"
                  @focus="receiptTotalPriceFocusInput(receiptForm.totalPrice)"
                  @blur="receiptTotalPriceBlurInput(receiptForm.totalPrice)"
                  @keypress="onKeypress($event, receiptForm.totalPrice)" />
              </div>
            </div>
            <div class="attach-receipt" v-if="!receiptTempFile">
              <p>แนบใบเสร็จ</p>
              <button class="button mt-2" @click="selectReceiptFile">
                <img src="/static/icons/supplier-attach-image-icon.svg" />เลือกไฟล์
              </button>
            </div>
            <div class="display-file-name mt-1 mb-2 ml-4 mr-4" v-else>
              <p>ไฟล์แนบ :</p>
              <div class="file-name">
                <p>{{ receiptTempFile.name }}</p>
                <p class="text-button ml-3" @click="selectReceiptFile">เลือกไฟล์</p>
                <p class="text-button" @click="receiptForm.uploadFile = null">ลบ</p>
              </div>
            </div>
            <input
              name="receiptFile"
              type="file"
              accept="application/pdf"
              ref="receiptFileRef"
              hidden
              @click="clearReceiptFileRef"
              @change="changeReceiptFile($event.target.files[0])"
            />
          </div>
        </div>
        <div class="right">
          <!-- Appointment -->
          <div class="form-wrapper" style="padding-bottom: 24px;">
            <div class="header">
              <div class="title">
                บ้านที่ต้องการแจ้ง  <span class="required" style="font-weight: 500;">(ต้องเลือก)</span>
              </div>
              <div class="value">เลือกโครงการหมู่บ้านให้ตรงกับใบแจ้งหนี้</div>
            </div>
            <div class="project">
              <p>โครงการ <span class="required">*</span></p>
              <el-select
                name="project"
                class="input-item"
                v-model="projectId"
                filterable
                clearable
                placeholder="เลือกโครงการ">
                <el-option
                  v-for="option in projectOptions"
                  :key="option.id"
                  :value="option.id"
                  :label="option.label" />
              </el-select>
              <div class="add-project-button">
                <button
                  class="button mt-4"
                  :class="projectId ? '' : 'disabled'"
                  :disabled="!projectId"
                  @click="handleAddProject()" >
                  <img :src="projectId
                    ? '/static/icons/supplier-add-project-icon.svg'
                    : '/static/icons/supplier-add-project-disabled-icon.svg'" />เพิ่มโครงการ
                </button>
              </div>
            </div>
            <div class="appointment"
              v-for="(project, projectIndex) in projectAppointments"
              :key="project.id">
              <div class="project-wrapper" @click="handleSelectProject(projectIndex)">
                <p class="name">{{ project.name }}</p>
                <div class="arrow-wrapper">
                  <div v-if="isProjectActive(projectIndex)" class="ml-2 arrow down"></div>
                  <div v-else class="ml-2 arrow up"></div>
                </div>
              </div>
              <div v-if="isProjectActive(projectIndex)">
                <div
                  v-for="(month, monthIndex) in project.months"
                  :key="month.fulfilledYearMonth">
                  <div class="month-wrapper mt-2" @click="handleSelectMonth(projectIndex, monthIndex)">
                    <p style="font-size: 14px;">
                      {{ month.fulfilledAtThaiDateText }} <span class="required" style="font-weight: 500;">*</span>
                    </p>
                    <div class="arrow-wrapper">
                      <div v-if="isMonthActive(projectIndex, monthIndex)" class="ml-2 arrow down"></div>
                      <div v-else class="ml-2 arrow up"></div>
                    </div>
                  </div>
                  <div v-if="isMonthActive(projectIndex, monthIndex)" class="fulfilled-month">
                    <div class="header">
                      <input
                        name="month"
                        type="checkbox"
                        class="checkbox"
                        :checked="month.isSelected"
                        @change="handleCheckboxChanged('month', `${project.id}_${monthIndex}`)" />
                      <p style="margin-left: auto;">{{ `${selectedAppointmentCount(month)} เลือกไว้` }}</p>
                      <p class="ml-4">{{ `${allAppointmentCount(month.homes)} ทั้งหมด` }}</p>
                    </div>
                    <div v-for="home in month.homes" :key="home.id">
                      <div class="home">
                        <p class="mb-1">{{ home.addressNo }}</p>
                        <div v-for="appointment in home.appointments" :key="appointment.id">
                          <div class="service mt-2">
                            <input
                              name="appointment"
                              type="checkbox"
                              class="checkbox" 
                              :checked="appointment.isSelected"
                              @change="handleCheckboxChanged('appointment', appointment.id)"
                              style="margin-top: 2px;" />
                            <p>{{ appointment.serviceName }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <confirm
      v-if="isShowCancelBillingDialog"
      @confirm="confirmCancelBilling"
      :data="cancelBillingDialog" />
    <confirm
      v-if="invoiceId"
      @confirm="navigateToInvoiceDetailPage"
      :data="createInvoiceSuccessDialog" />
  </page-wrapper>
</template>

<script>
import PageWrapper from "../components/SupplierPageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import { isEmpty } from "ramda";
import { DateTime } from "luxon";
import { uploadFile } from "../../lib/upload";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import {
  formatBaht,
  handleInputValidation,
  removeNonNumericCharacters,
} from "../../lib/currencyFormatter";
import { convertPriceStringToInt } from "@/lib/formatter";
import { existValueAndEmptyString } from '../../../../lib/util';

export default {
  components: { PageWrapper, VuePdfApp },
  data() {
    const invoiceForm = {
      invoiceNo: null,
      dateTime: null,
      totalPrice: null,
      uploadFile: null,
    };

    const receiptForm = {
      receiptNo: null,
      dateTime: null,
      totalPrice: null,
      uploadFile: null,
    };

    const cancelBillingDialog = {
      title: " ",
      detail: "ต้องการยกเลิกการสร้างใบแจ้งหนี้หรือไม่?",
      buttonCancel: "ย้อนกลับ",
      buttonSubmit: "ยืนยัน"
    };

    const createInvoiceSuccessDialog = {
      title: " ",
      detail: "ยื่นออกใบแจ้งหนี้สำเร็จ",
      buttonSubmit: "ตกลง"
    };

    const vuePdfConfig = {
      toolbar: {
        toolbarViewerLeft: false,
        toolbarViewerRight: {
          openFile: false,
          print: false,
          viewBookmark: false,
        },
      }
    };

    return {
      vuePdfConfig,
      invoiceForm,
      receiptForm,
      projectResults: [],
      projectId: null,
      selectedProjects: [],
      activeSections: [],
      fulfilledMonthsProjects: [],
      projectAppointments: [],
      cancelBillingDialog,
      isShowCancelBillingDialog: false,
      createInvoiceSuccessDialog,
      invoiceId: null
    };
  },
  async created() {
    await this.setupProjects();
  },
  methods: {
    startLoading() {
      this.$store.state.loader = true;
    },
    stopLoading() {
      this.$store.state.loader = false;
    },
    async setupProjects() {
      try {
        this.startLoading();

        const projects = await this.fetchProjects();

        this.projectResults = projects;

        this.stopLoading();
      } catch (error) {
        alert("ไม่สามารถดึงข้อมูลโครงการได้");

        this.stopLoading();
      }
    },
    async setupAppointmentFulfilledList(projectId) {
      const params = { project_id: projectId };

      return await this.fetchAppointmentFulfilledList(params);
    },
    async setupProjectAppointments() {
      this.projectAppointments = this.selectedProjects.map((project, projectIndex) => {
        // get fulfilled months
        const fulfilledMonths = this.fulfilledMonthsProjects[projectIndex];

        return {
          id: project.id,
          name: project.label,
          months: fulfilledMonths.map((month, monthIndex) => {
            const selectedMonth = this.projectAppointments && this.projectAppointments[projectIndex]
              && this.projectAppointments[projectIndex].id === project.id
              && this.projectAppointments[projectIndex].months
              && this.projectAppointments[projectIndex].months[monthIndex]
              ? this.projectAppointments[projectIndex].months[monthIndex]
              : undefined;
            // set isSelected month
            const isSelectedMonth = selectedMonth ? selectedMonth.isSelected : false;

            // get selected appointments
            const selectedAppointments = selectedMonth ? selectedMonth.homes.flatMap(home =>
              home.appointments.filter(appointment => appointment.isSelected)
            ) : [];

            return {
              ...month,
              isSelected: isSelectedMonth,
              homes: month.homes.map(home => {
                return {
                  ...home,
                  appointments: home.appointments.map(appointment => {
                    // set isSelected appointment
                    const isSelectedAppointment = selectedAppointments.some(
                      selectedAppointment => selectedAppointment.id === appointment.id
                    );

                    return {
                      ...appointment,
                      isSelected: isSelectedAppointment
                    };
                  })
                };
              })
            };
          })
        };
      });

      if (this.projectAppointments) await this.setupActiveSections();
    },
    async setupActiveSections() {
      this.activeSections = this.projectAppointments.map((project, projectIndex) => {
        const isLastProject = this.projectAppointments.length - 1 === projectIndex;

        return {
          isProjectActive: isLastProject,
          months: project.months.map((_, monthIndex) => {
            const activeMonth = this.activeSections
              && this.activeSections[projectIndex]
              && this.activeSections[projectIndex].months
              && this.activeSections[projectIndex].months[monthIndex]
              ? this.activeSections[projectIndex].months[monthIndex] : undefined;

            const isMonthActive = activeMonth ? activeMonth.isMonthActive : true;

            return { isMonthActive: isMonthActive };
          })
        };
      });

      this.projectId = null;
    },
    async handleAddProject() {
      if (this.hasProject) {
        alert("ไม่สามารถเลือกโครงการซ้ำได้");

        this.projectId = null;

        return;
      }

      this.startLoading();

      // get fulfilled months
      const fulfilledMonths = await this.setupAppointmentFulfilledList(this.projectId);

      // setup project appointments
      if (!isEmpty(fulfilledMonths)) {
        this.fulfilledMonthsProjects.push(fulfilledMonths);

        this.selectedProjects.push(this.project);

        await this.setupProjectAppointments();

        this.stopLoading();
      } else {
        this.projectId = null;

        alert("ไม่พบข้อมูลการนัดหมาย");
      }
    },
    handleSelectProject(index) {
      this.activeSections[index].isProjectActive = !this.isProjectActive(index);
    },
    handleSelectMonth(projectIndex, monthIndex) {
      this.activeSections[projectIndex].months[monthIndex].isMonthActive
        = !this.isMonthActive(projectIndex, monthIndex);
    },
    async handleCheckboxChanged(key, value) {
      // handle month checkbox changed
      if (key === "month") {
        this.projectAppointments = this.projectAppointments.map((project) => {
          return {
            ...project,
            months: project.months.map((month, monthIndex) => {
              const compareValue = `${project.id}_${monthIndex}`;
              const isSelectedMonth = compareValue === value;
              const monthSelected = isSelectedMonth ? !month.isSelected : month.isSelected;

              return {
                ...month,
                isSelected: monthSelected,
                homes: month.homes.map(home => {
                  return {
                    ...home,
                    appointments: home.appointments.map(appointment => {
                      const appointmentSelected = isSelectedMonth ? monthSelected : appointment.isSelected;

                      return {
                        ...appointment,
                        isSelected: appointmentSelected
                      };
                    })
                  };
                })
              };
            })
          };
        });
      }

      // handle appointment checkbox changed
      if (key === "appointment") {
        this.projectAppointments = this.projectAppointments.map(project => {
          const months = project.months.map(month => {
            const updatedAppointments = month.homes.map(home => {
              return {
                ...home,
                appointments: home.appointments.map(appointment => {
                  const appointmentSelected = appointment.id === value
                    ? !appointment.isSelected : appointment.isSelected;

                  return {
                    ...appointment,
                    isSelected: appointmentSelected
                  };
                })
              };
            });

            const isSelectedAllAppointments = updatedAppointments.every(
              home => home.appointments.every(appointment => appointment.isSelected)
            );

            return {
              ...month,
              isSelected: isSelectedAllAppointments,
              homes: updatedAppointments
            };
          })

          return {
            ...project,
            months: months
          };
        });
      }
    },
    async handleCancelBilling() {
      const {
        invoiceNo,
        dateTime: invoiceDateTime,
        totalPrice: invoiceTotalPrice,
        uploadFile: invoiceUploadFile
      } = this.invoiceForm

      const {
        receiptNo,
        dateTime: receiptDateTime,
        totalPrice: receiptTotalPrice,
        uploadFile: receiptUploadFile
      } = this.receiptForm

      const isAppointmentSelected = this.projectAppointments.some(project => project.months.some(
        month => month.homes.some(home => home.appointments.some(appointment => appointment.isSelected))
      ));

      if (invoiceNo || invoiceDateTime || invoiceTotalPrice || invoiceUploadFile ||
        receiptNo || receiptDateTime || receiptTotalPrice || receiptUploadFile || isAppointmentSelected) {
        this.isShowCancelBillingDialog = true;
      } else {
        this.navigateToInvoiceDashboardPage();
      }
    },
    async handleSubmitBilling() {
      const  {
        invoiceNo,
        dateTime: invoiceDateTime,
        totalPrice: invoiceTotalPrice,
        uploadFile: invoiceUploadFile
      } = this.invoiceForm

      const {
        receiptNo,
        dateTime: receiptDateTime,
        totalPrice: receiptTotalPrice,
        uploadFile: receiptUploadFile
      } = this.receiptForm

      const isAppointmentSelected = this.projectAppointments.some(project => project.months.some(
        month => month.homes.some(home => home.appointments.some(appointment => appointment.isSelected))
      ));

      
      const isAllRequiredFieldsFilled = existValueAndEmptyString(invoiceNo)
        && existValueAndEmptyString(invoiceDateTime)
        && existValueAndEmptyString(invoiceTotalPrice)
        && existValueAndEmptyString(invoiceUploadFile)
        && isAppointmentSelected;
      
      // Validate all required fields
      if (!isAllRequiredFieldsFilled) {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");

        return;
      }

      const hasOptionalFieldsFilled = existValueAndEmptyString(receiptNo)
        || existValueAndEmptyString(receiptDateTime)
        || existValueAndEmptyString(receiptTotalPrice)
        || existValueAndEmptyString(receiptUploadFile);

      // Validate optional fields
      if (hasOptionalFieldsFilled) {
        const isAllOptionalFieldsFilled = existValueAndEmptyString(receiptNo)
          && existValueAndEmptyString(receiptDateTime)
          && existValueAndEmptyString(receiptTotalPrice)
          && existValueAndEmptyString(receiptUploadFile);

        // Validate all optional fields
        if (!isAllOptionalFieldsFilled) {
          alert("กรุณากรอกข้อมูลใบเสร็จให้ครบถ้วน");

          return;
        }
      }

      try {
        this.startLoading();

        // Define params
        const params = {};

        // Upload invoice and receipt file
        const invoiceDocumentKey = await uploadFile(invoiceUploadFile.file, 'invoice')
        const receiptDocumentKey = receiptUploadFile ? await uploadFile(receiptUploadFile.file, 'receipt') : null;

        // Set parameters
        params.invoice_no = invoiceNo;
        params.invoice_date =
          DateTime.fromJSDate(invoiceDateTime).startOf("day").toISO();
          params.invoice_total_price =
          convertPriceStringToInt(removeNonNumericCharacters(invoiceTotalPrice));
          params.invoice_document_key = invoiceDocumentKey;
          params.appointment_list = this.projectAppointments.map(project => {
          return {
            project_id: project.id,
            appointments: project.months.flatMap(
              month => month.homes.flatMap(
                home => home.appointments.filter(appointment => appointment.isSelected)
                  .map(appointment => appointment.id)
              )
            )
          };
        }); 
        if (receiptNo) params.receipt_no = receiptNo;
        if (receiptDateTime) params.receipt_date =
          DateTime.fromJSDate(invoiceDateTime).startOf("day").toISO();
        if (receiptTotalPrice) params.receipt_total_price =
          convertPriceStringToInt(removeNonNumericCharacters(receiptTotalPrice));
        if (receiptDocumentKey) params.receipt_document_key = receiptDocumentKey;

        // Create invoice
        await this.createInvoice(params)

        this.stopLoading();
      } catch (error) {
        alert("ไม่สามารถสร้างใบแจ้งหนี้ได้");

        this.stopLoading();
      }
    },
    confirmCancelBilling(isConfirm) {
      if (!isConfirm) {
        this.isShowCancelBillingDialog = false;
        return;
      }

      this.stopLoading();

      this.navigateToInvoiceDashboardPage();
    },
    navigateToInvoiceDashboardPage() {
      this.$router.push({
        name: "SupplierInvoiceDashboard",
        query: { status: 'un_billed' }
      });
    },
    navigateToInvoiceDetailPage() {
      this.$router.push({
        name: "SupplierInvoiceDetail",
        params: {
          invoiceId: this.invoiceId,
          status: 'in_progress'
        }
      });
    },
    allAppointmentCount(homes) {
      return homes.reduce((acc, home) => acc + home.appointments.length, 0);
    },
    selectedAppointmentCount(month) {
      return month.homes.reduce(
        (acc, home) => acc + home.appointments.filter(appointment => appointment.isSelected).length, 0
      );
    },
    clearInvoiceFileRef() {
      this.$refs.invoiceFileRef.value = "";
    },
    clearReceiptFileRef() {
      this.$refs.receiptFileRef.value = "";
    },
    selectInvoiceFile() {
      this.$refs.invoiceFileRef.click();
    },
    selectReceiptFile() {
      this.$refs.receiptFileRef.click();
    },
    async changeInvoiceFile(file) {
      if (await this.canAttachImage(file)) {
        try {
          this.invoiceForm.uploadFile = await this.createTempFile(file, 'invoice');
        } catch (error) {
          alert("เพิ่มรูปไม่สำเร็จ กรุณาลองใหม่อีกครั้ง หรือเลือกรูปอื่น");
        }
      }
    },
    async changeReceiptFile(file) {
      if (await this.canAttachImage(file)) {
        try {
          this.receiptForm.uploadFile = await this.createTempFile(file, 'receipt');
        } catch (error) {
          alert("เพิ่มรูปไม่สำเร็จ กรุณาลองใหม่อีกครั้ง หรือเลือกรูปอื่น");
        }
      }
    },
    async canAttachImage(file) {
      const isImageLarger = file.size / 1024 / 1024 > 1;
      
      // check image size
      if (isImageLarger) {
        alert(`จำกัดขนาดไฟล์ไม่เกิน 1 MB`);

        return false;
      }

      return true;
    },
    async createTempFile(file, key) {
      // convert file to url
      const blob = new Blob([file]);
      const objectUrl = URL.createObjectURL(blob);

      // create temp file
      return {
        key: key,
        file: file,
        name: file.name,
        url: objectUrl
      };
    },
    invoiceTotalPriceFocusInput(value) {
      if (value) this.invoiceForm.totalPrice = removeNonNumericCharacters(value);
    },
    invoiceTotalPriceBlurInput(value) {
      if (value) this.invoiceForm.totalPrice = formatBaht(value);
    },
    receiptTotalPriceFocusInput(value) {
      if (value) this.receiptForm.totalPrice = removeNonNumericCharacters(value);
    },
    receiptTotalPriceBlurInput(value) {
      if (value) this.receiptForm.totalPrice = formatBaht(value);
    },
    onKeypress(event, value) {
      if (value) handleInputValidation(event, value);
    },
    isProjectActive(index) {
      return this.activeSections[index].isProjectActive;
    }, 
    isMonthActive(projectIndex, monthIndex) {
      return this.activeSections[projectIndex].months[monthIndex].isMonthActive;
    },
    async fetchProjects() {
      return await baanRueJaiClient.others.supplier.getCreateInvoiceProjects();
    },
    async fetchAppointmentFulfilledList(params) {
      return await baanRueJaiClient.others.supplier.getAppointmentFulfilledList(params);
    },
    async createInvoice(params) {
      try {
        const { partner_invoice_id: partnerInvoiceId }
          = await baanRueJaiClient.others.supplier.createInvoice(params);

        if (partnerInvoiceId) this.invoiceId = partnerInvoiceId;
      } catch (error) {
        alert("ไม่สามารถสร้างใบแจ้งหนี้ได้");
      }
    },
  },
  computed: {
    loader() {
      return this.$store.state.loader;
    },
    projectOptions() {
      if (!this.projectQuery) {
        return this.projectResults;
      }

      return this.projectResults.filter(project => {
        return project.label.includes(this.projectQuery);
      });
    },
    hasProject() {
      return this.selectedProjects.some(project => project.id === this.projectId);
    },
    project() {
      return this.projectOptions.find(project => project.id === this.projectId);
    },
    invoiceTempFile() {
      const { uploadFile } = this.invoiceForm;

      return uploadFile ? uploadFile : null;
    },
    invoiceTempFileUrl() {
      const { uploadFile } = this.invoiceForm;

      return uploadFile && uploadFile.url ? uploadFile.url : null;
    },
    receiptTempFile() {
      const { uploadFile } = this.receiptForm;

      return uploadFile ? uploadFile : null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.content-wrapper {
  display: flex;
  flex-direction: column;
}

.sub-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid $color-light-gray-1;

  .title {
    font-size: 24px;
    font-weight: 700;
  }

  .button-wrapper {
    display: flex;
    flex-direction: row;

    > .button {
      width: 168px;
      height: 44px;
      font-weight: bold;
      font-size: $font-16;
      border-radius: 8px;
      margin-right: auto;

      img {
        margin-right: 8px;
      }
    }

    > .cancel-button {
      color: $black;
      background: transparent;
      border: 1px solid $color-light-gray-1;

      &:hover:not(:disabled) {
        background: $color-light-gray-1-hover;
      }
    }

    > .confirm-button {
      color: $white;
      background: $supplier-primary-color;
      border: none;

      &:hover:not(:disabled) {
        background: $supplier-primary-light-color;
      }
    }
  }
}

.description {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-inline: 24px;
  padding: 24px;
  border: 1px solid $color-light-gray-1;
  border-radius: 8px;

  > .content {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .item {
      display: flex;
      flex-direction: row;
      align-items: end;

      p {
        font-size: 16px;
      }

      .status-text {
        font-size: 20px;
        font-weight: 700;
        line-height: 1.6;
        color: #F4643A;
      }

      .value {
        font-weight: 700;
      }
    }
  }

  > .status {
    display: flex;
    flex-direction: row;
    width: 205px;
    height: 48px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;

    .content-wrapper {
      display: flex;
      flex-direction: row;
      align-items: end;

      .title {
        font-size: 14px;
      }

      .value {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.3;
      }

      .text_in_progress,
      .text_document_approved,
      .text_payment_approved,
      .text_transfer_confirmed {
        color: #5175E1;
      }

      .text_rejected {
        color: #F4643A;
      }
    }
  }

  .background_in_progress,
  .background_document_approved,
  .background_payment_approved,
  .background_transfer_confirmed {
    background: #5175E11A;
  }

  .background_rejected {
    background: #F4643A1A;
  }
}

.body {
  width: 100%;
  display: grid;
  grid-template-columns: calc(60% - 12px) calc(40% - 12px);
  grid-gap: 20px;
  padding-inline: 24px;
  padding-bottom: 32px;

  .required {
    color: red;
  }

  .header {
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    background-color: #5175e11a;

    > .title {
      font-size: 18px;
      font-weight: 700;
      color: #5175E1;
    }

    > .value {
      font-size: 14px;
    }
  }

  .form-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid $color-light-gray-1;
    border-radius: 8px;
  }

  .left {
    .form {
      z-index: 2;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 16px;
      padding: 24px;

      .item {
        display: flex;
        flex-direction: column;
      }
    }

    .preview-invoice {
      z-index: 1;
      position: relative;
      width: 100%;
      padding: 0 24px;

      .display-file {
        height: 360px;
        border-radius: 8px;
      }

      .attach-file {
        position: absolute;
        top: 0;
        left: 0;
        width:100%;    
        height:100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        button:hover:not(:disabled) {
          background: #ffffffb9;
        }
      }
    }

    .attach-receipt {
      display: flex;
      flex-direction: column;
      width: fit-content;
      padding: 0 24px 24px 24px;

      button:hover:not(:disabled) {
        background: #0000000a;
      }
    }

    p {
      font-size: 16px;
    }

    .display-file-name {
      display: flex;
      flex-direction: column;

      p {
        font-size: 14px;
      }
      
      .file-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 0.9;

        p {
          font-size: 16px;
          font-weight: 700;
        }

        .text-button {
          padding: 4px 8px;
          color: #5175E1;
          cursor: pointer;
        }
      }
    }
  }

  .right {
    display: flex;
    flex-direction: column;

    .project {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 24px;

      .add-project-button {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      p {
        font-size: 16px;
      }

      .disabled {
        color: $color-light-gray-1;
        border: 1px solid $color-light-gray-1;
      }

      button:hover:not(:disabled) {
        background: #0000000a;
      }
    }

    .appointment {
      display: flex;
      flex-direction: column;
      padding: 0 24px 0 24px;

      .project-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid $color-light-gray-1;
        cursor: pointer;

        .name {
          font-size: 18px;
          font-weight: 700;
        }
      }

      .month-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        padding-bottom: 8px;
      }

      .arrow-wrapper {
        margin-left: auto;
        padding: 4px;

        .arrow {
          width: 8px;
          height: 8px;
          border: solid $black;
          border-width: 0 1.5px 1.5px 0;
          display: inline-block;
        }

        > .up {
          transform: rotate(-135deg);
          -webkit-transform: rotate(-135deg);
        }

        > .down {
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
        }
      }

      .fulfilled-month {
        display: flex;
        flex-direction: column;
        border: 1px solid #d9d9d9;

        .header {
          display: flex;
          flex-direction: row;
          align-items: center;
          background: #F7F7F7;
          padding: 8px 24px;
          border-bottom: 1px solid #d9d9d9;

          p {
            font-size: 14px;
            color: #808080;
          }
        }

        .home {
          display: flex;
          flex-direction: column;
          padding: 16px 24px;
          background: #5175E11A;
          border-bottom: 1px solid #d9d9d9;

          p {
            font-size: 16px;
            font-weight: 700;
          }

          .service {
            display: flex;
            flex-direction: row;

            p {
              font-size: 14px;
              font-weight: 500;
              margin-left: 12px;
            }
          }
        }
      }

      .checkbox {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
      }
    }
  }

  .button {
    width: max-content;
    height: 44px;
    font-weight: bold;
    font-size: $font-16;
    border-radius: 8px;
    color: $supplier-primary-color;
    background: #FFFFFF;
    border: 1px solid $supplier-primary-color;

    img {
      margin-right: 8px;
    }
  }
}

input {
  font-size: 14px;
  color: #606266;
  height: 40px;
  padding-inline: 16px;
  line-height: 40px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}

input:focus {
  border-color: #e27024 !important;
}

.currency-input {
  --placeholder-color: #c0c4cc;
}

.currency-input::placeholder {
  color: var(--placeholder-color);
}

.input-item {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner,
.el-select {
  width: 100%;
}

.el-textarea,
.el-input {
  font-size: $font-14;
}

@media (max-width: ($m-size - 1)) {
  .sub-title {
    padding: 16px;

    .title {
      font-size: 18px;
    }

    .button-wrapper {
      > .button {
        width: 120px;
        height: 40px;
        font-size: $font-14;

        img {
          width: 14px;
        }
      }
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    padding-inline: 20px;
    padding-bottom: 24px;

    .header {
      padding: 16px 20px;
    }

    .left {
      .form {
        grid-gap: 8px;
        padding: 16px;
      }

      .preview-pdf {
        padding: 0 16px;
      }

      .attach-receipt {
        padding: 0 16px 20px 16px;
      }

      .display-file-name {
        .file-name {
          p {
            font-size: 14px;
          }
        }
      }
    }

    .right {
      .project {
        padding: 16px;
      }

      .appointment {
        padding: 0 16px 20px 16px;

        .fulfilled-month {
          .header {
            padding: 8px 16px;
          }

          .home {
            padding: 16px;

            .service {
              p {
                margin-left: 8px;
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .sub-title {
    padding: 16px;

    .title {
      font-size: 18px;
    }

    .button-wrapper {
      > .button {
        width: 140px;
        height: 40px;
        font-size: $font-14;

        img {
          width: 14px;
        }
      }
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    padding-inline: 16px;
    padding-bottom: 24px;

    .header {
      padding: 16px 20px;

      > .title {
        font-size: 16px;
      }

      > .value {
        font-size: 13px;
      }
    }

    .left {
      .form {
        grid-gap: 8px;
        padding: 16px;
      }

      .preview-pdf {
        padding: 0 16px;
      }

      .attach-receipt {
        padding: 0 16px 20px 16px;
      }

      .display-file-name {
        .file-name {
          p {
            font-size: 14px;
          }
        }
      }
    }

    .right {
      .project {
        padding: 16px;
      }

      .appointment {
        padding: 0 16px 20px 16px;

        .fulfilled-month {
          .header {
            padding: 8px 16px;
          }

          .home {
            padding: 16px;

            .service {
              p {
                margin-left: 8px;
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .sub-title {
    padding: 16px 20px;

    .title {
      font-size: 20px;
    }

    .button-wrapper {
      > .button {
        width: 158px;
        height: 40px;
        font-size: $font-14;

        img {
          width: 16px;
        }
      }
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    padding-inline: 20px;
    padding-bottom: 24px;

    .header {
      padding: 16px 20px;
    }

    .left {
      .form {
        grid-gap: 16px;
        padding: 24px;

        .item {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/pages/CreateInvoice.vue